import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export default class RoomTypesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "room_type", "/api/v1/room_types");
    this.refreshPageContentAfterCommit = true;
  }
}
